define(['jquery',
        'core/urls'],
    function($, urls) {

        function ConnectivityCheck(){
            $.ajax({
                type: 'GET',
                url: urls['ticketsource:screenconnect-connectivity'](),
                dataType: 'json',
                success: function(data){
                     if(data.status === 'connected'){
                        $('#connectivity-status-checking-screenconnect').hide();
                        $('#connectivity-status-screenconnect p').hide();
                        $('#connectivity-status-connected-screenconnect').show();
                        $('#connectivity-status-notconnected-screenconnect').hide();
                    } else if(data.status === 'disconnected') {
                        $('#connectivity-status-checking-screenconnect').hide();
                        $('#connectivity-status-notconnected-screenconnect').show();
                        $('#connectivity-status-checking-screenconnect').hide();
                        $('#connectivity-status-screenconnect p').show();
                    }
                }
            });
        }

        return {
            init: function() {
                ConnectivityCheck();
            }
        };
    }
);